import React, { Component } from 'react';
import 'ant-design-pro/dist/ant-design-pro.css';

import createHistory from 'history/createHashHistory'

import Son from "./../LoginRouter/LoginRouterMain"
import { Alert, Checkbox, Icon } from 'antd';
import Login from 'ant-design-pro/lib/Login';
import GlobalFooter from 'ant-design-pro/lib/GlobalFooter';

import "./../style.css"

const history = createHistory();

const { Tab, UserName, Password, Mobile, Captcha, Submit } = Login;

const copyright = <div>技术支持：江苏户传科技有限公司&emsp;联系电话：025-83720315</div>;

let _LoginMain = null;
class App extends Component {
    state = {
        loginBottomClass: ""
    }
    componentDidMount() {
        _LoginMain = this;

        if (document.documentElement.clientHeight <= 800) {
            _LoginMain.setState({
                loginBottomClass: "loginBottomOther"
            })
        } else {
            _LoginMain.setState({
                loginBottomClass: "loginBottom"
            })
        }

        //监听屏幕大小变化,改变底部样式
        window.addEventListener('resize', function () {
            if (document.documentElement.clientHeight <= 800) {
                _LoginMain.setState({
                    loginBottomClass: "loginBottomOther"
                })
            } else {
                _LoginMain.setState({
                    loginBottomClass:"loginBottom"
                })
            }
        })
    }
    render() {
        return (
            <div>
                <Son />
                <div className={this.state.loginBottomClass}>
                    <GlobalFooter copyright={copyright} />
                </div>
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Login/Login/LoginMain.js